// Parses UAE Federal Tax Authority VAT-invoice QR (TLV Base64 encoded).
// Returns { seller, vatNumber, timestamp, total, vat } or null when not a VAT-QR.
// Spec: FTA e-invoicing — tag 1=seller, 2=vat-no, 3=timestamp, 4=invoice-total, 5=vat-amount.
export function parseUaeVatQr(text) {
  if (!text || typeof text !== "string") return null;
  const trimmed = text.trim();
  let bytes;
  try {
    const b64 = trimmed.replace(/-/g, "+").replace(/_/g, "/");
    const raw = atob(b64);
    bytes = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
  } catch { return null; }
  if (bytes.length < 4) return null;
  const dec = new TextDecoder("utf-8", { fatal: false });
  const out = {};
  let i = 0;
  while (i + 2 <= bytes.length) {
    const tag = bytes[i]; const len = bytes[i + 1]; i += 2;
    if (i + len > bytes.length) return null;
    const val = dec.decode(bytes.slice(i, i + len));
    i += len;
    if (tag === 1) out.seller = val;
    else if (tag === 2) out.vatNumber = val;
    else if (tag === 3) out.timestamp = val;
    else if (tag === 4) out.total = parseFloat(val);
    else if (tag === 5) out.vat = parseFloat(val);
  }
  if (!out.seller && out.total == null) return null;
  return out;
}
